import React, { useState, useEffect } from 'react';
import './Challenge.css';
import { CSVLink } from 'react-csv';
import { useUser } from '../context/UserContext';
import Select from 'react-select';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';
const LearnTrailReports = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedAcademy, setSelectedAcademy] = useState('');
  const getFormattedDate = (date) => date.toISOString().split('T')[0];
  const today = new Date();
  const token = localStorage.getItem('auth-token');
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);
  const [fromDate, setFromDate] = useState(getFormattedDate(tenDaysAgo));
  const [toDate, setToDate] = useState(getFormattedDate(today));
  const [LearnTrail, setLearnTrail] = useState([]);
  const [academyNameMap, setAcademyNameMap] = useState({});
  const { selectedCenter, userData } = useUser();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (selectedCenter && academyNameMap[selectedCenter]) {
      setSelectedAcademy(selectedCenter);
    }
  }, [selectedCenter, academyNameMap]);


  const fetchData = async () => {
    setError('');
    setLoading(true);
    const apiUrl = process.env.REACT_APP_API_ACADEMY_LEARN_TRIALS;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          fromDate: fromDate,
          toDate: toDate,
        }),
      });

      const result = await response.json();

      if (result.success) {
        setAcademyNameMap(result.data.academyNameMap);
        const bookings = result.data.bookings.map((booking) => ({
          name: booking?.name || '-',
          phone: booking?.contact || '-',
          batch: booking?.batch?.name || '-',
          date: booking?.trialBookDate ? new Date(booking.trialBookDate).toISOString().split('T')[0] : '-',
          time: formatTime(booking?.startTime) || '-',
          academy: booking?.academyId || '-',
        }));
        setLearnTrail(bookings);
      } else {
        setError("Failed to fetch data");
      }
    } catch (error) {
      setError("Error fetching data");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [fromDate, toDate]);

  const formatTime = (time) => {
    const [hour, minute] = time.split(':');
    const hours = parseInt(hour, 10);
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHour = hours % 12 || 12;
    return `${formattedHour}:${minute} ${period}`;
  };

  const headers = [
    { key: 'name', label: 'Name' },
    { key: 'phone', label: 'Phone' },
    { key: 'batch', label: 'Batch' },
    { key: 'date', label: 'Date' },
    { key: 'time', label: 'Time' },
  ];

  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedAcademy, fromDate, toDate]);

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const filteredLearnTrail = LearnTrail.filter((learn) => {
    const matchesSearch = [learn.name, learn.phone, learn.batch].some((field) =>
      field.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const isAcademyUser = userData?.userType === "ACADEMY";
    const matchesAcademy = isAcademyUser
      ? (selectedAcademy === ""
        ? userData.academyIds.includes(Number(learn.academy))
        : Number(learn.academy) === Number(selectedAcademy))
      : (selectedAcademy === "" || Number(learn.academy) === Number(selectedAcademy));

    const matchesUserAcademy =
      !isAcademyUser ||
      (selectedAcademy === "" && Array.isArray(userData.academyIds) && userData.academyIds.length > 0) ||
      (Array.isArray(userData.academyIds) && userData.academyIds.includes(Number(selectedAcademy)));
    const matchesDate =
      (fromDate === "" || new Date(learn.date).getTime() >= new Date(fromDate).getTime()) &&
      (toDate === "" || new Date(learn.date).getTime() <= new Date(toDate).getTime());

    return matchesSearch && matchesAcademy && matchesDate && matchesUserAcademy;
  });

  const sortedLearnTrail = React.useMemo(() => {
    let sortableItems = [...filteredLearnTrail];
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [filteredLearnTrail, sortConfig]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedLearnTrail.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredLearnTrail.length / rowsPerPage);

  const handleSort = (column) => {
    let direction = 'asc';
    if (sortConfig.key === column && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: column, direction });
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const renderPagination = () => {
    return Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
      <button
        key={page}
        className={`page-number ${currentPage === page ? 'active' : ''}`}
        onClick={() => handlePageClick(page)}
      >
        {page}
      </button>
    ));
  };
  const totalEntries = filteredLearnTrail.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  const getAcademyOptions = () => {
    const academyOptions =
      userData?.userType === 'ACADEMY'
        ? userData.academyIds
          .map(id => ({
            value: id,
            label: academyNameMap[id],
          }))
          .filter(option => option.label)
        : Object.keys(academyNameMap)
          .map(academyId => ({
            value: academyId,
            label: academyNameMap[academyId],
          }));

    return academyOptions;
  };

  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">

        <div className="floating-select">
          <Select
            id="selectedAcademy"
            className={`sales-filter-court-booking ${selectedAcademy ? "has-value" : ""}`}
            options={getAcademyOptions()}
            value={
              selectedAcademy
                ? { value: selectedAcademy, label: academyNameMap[selectedAcademy] }
                : null
            }
            onChange={(selectedOption) => {
              setSelectedAcademy(selectedOption?.value || "");
            }}
            isClearable
            placeholder="Select Academy"
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {selectedAcademy && <label htmlFor="selectedAcademy">Academy</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${fromDate ? "has-value" : ""}`}
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value);
            }}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />

          {fromDate && <label htmlFor="fromDate">Start Date</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${toDate ? "has-value" : ""}`}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          {toDate && <label htmlFor="toDate">End Date</label>}
        </div>
      </div>

      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        <CSVLink
          data={filteredLearnTrail.map(({ phone, ...rest }) => rest)}
          headers={headers.filter(header => header.key !== 'phone')}
          filename="LearnTrialReportreports.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>
      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
          <option value={100}>100 items per page</option>
        </select>
        <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchData}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>

      </div>

      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredLearnTrail.length === 0 && (
        <div className="error-message">No data available</div>
      )}


      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr className="challenges-header-row">
              {headers.map(({ key, label }) => (
                <th
                  key={key}
                  className="challenges-column"
                  onClick={() => handleSort(key)}
                >
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon 
              ${sortConfig.key === key ? 'active' : ''} 
              ${sortConfig.key === key && sortConfig.direction === 'asc' ? 'asc' : ''} 
              ${sortConfig.key === key && sortConfig.direction === 'desc' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((learn) => (
              <tr key={learn.id} >
                <td>{learn.name}</td>
                <td>{learn.phone}</td>
                <td>{learn.batch}</td>
                <td>{learn.date}</td>
                <td>{learn.time}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* )} */}
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default LearnTrailReports
